import { Box, Modal } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    container: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 'calc(100% - 48px)',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        padding: 24,
        minHeight: '68vh',
        borderRadius: 16,
        backgroundColor: 'white',
        outline: 'none',
    },
    closeBtn: {
        position: 'absolute',
        top: '20px',
        right: '12px',
    },
    image: {
        width: '100%',
        height: 'auto',
    },
}));

export const HelpModal = ({ data, visible, onHide }) => {
    const styles = useStyles();

    return (
        <Modal open={visible} onClose={onHide} disableEnforceFocus>
            <Box className={styles.container}>
                {data && <img src={data?.url} className={styles.image} alt="quiz_help" />}
                <CloseIcon
                    className={styles.closeBtn}
                    name="quiz-help-close-btn"
                    width={24}
                    htmlColor="black"
                    onClick={onHide}
                />
            </Box>
        </Modal>
    );
};
